import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css'; // Don't forget the CSS file!

export default function OptionText({ text }) {
  const isLatex = /^\s*\$[\s\S]*\$\s*$/.test(text);

  const safeText = isLatex
    ? text
    : text
      .replace(/^(\s*)([+\-*>] )/gm, '$1\\$2') // Escapes list & blockquote items at line start
      .replace(/(^|\s)([><+\-*]=?)(?=\s|$)/g, '$1\\$2');

  return (
    <div className="option-text">
      <ReactMarkdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
      >
        {safeText}
      </ReactMarkdown>
    </div>
  );
}